var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2476 38.2018C73.2476 35.1291 72.9982 32.8868 72.4586 30.5615H37.3712V44.4302H57.9667C57.5517 47.8768 55.3094 53.0672 50.3265 56.555L50.2566 57.0193L61.3506 65.6137L62.1192 65.6904C69.1781 59.1712 73.2476 49.5792 73.2476 38.2018Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3712 74.7422C47.4613 74.7422 55.932 71.4201 62.1192 65.6901L50.3265 56.5547C47.1707 58.7554 42.9352 60.2918 37.3712 60.2918C27.4887 60.2918 19.101 53.7728 16.111 44.7622L15.6728 44.7994L4.13706 53.727L3.98621 54.1464C10.1316 66.3542 22.7548 74.7422 37.3712 74.7422Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.111 44.7622C15.322 42.437 14.8655 39.9454 14.8655 37.371C14.8655 34.7964 15.322 32.3051 16.0695 29.9798L16.0486 29.4846L4.36832 20.4136L3.98616 20.5953C1.45334 25.6613 0 31.3501 0 37.371C0 43.3919 1.45334 49.0805 3.98616 54.1464L16.111 44.7622Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3712 14.4501C44.3886 14.4501 49.1222 17.4813 51.8213 20.0144L62.3683 9.71651C55.8908 3.69561 47.4613 0 37.3712 0C22.7548 0 10.1316 8.38769 3.98621 20.5955L16.0695 29.98C19.101 20.9694 27.4887 14.4501 37.3712 14.4501Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider6);
export default __webpack_public_path__ + "static/media/slider-6.0e8975293321da8dacfb0276c0dbd843.svg";
export { ForwardRef as ReactComponent };